import { render, staticRenderFns } from "./IDCardValidate.vue?vue&type=template&id=8e5baf9a&scoped=true&"
import script from "./IDCardValidate.vue?vue&type=script&lang=js&"
export * from "./IDCardValidate.vue?vue&type=script&lang=js&"
import style0 from "./IDCardValidate.vue?vue&type=style&index=0&id=8e5baf9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5baf9a",
  null
  
)

export default component.exports